import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import React from 'react';

import useDeletePermissionDialogLogic, {
  DeletePermissionDialogComponentProps,
} from './useDeletePermissionDialogLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    tabHeader: {
      color: theme.palette.primary.main,
    },
    button: {
      color: theme.palette.common.white,
    },
    deleteButton: {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.dark,
      },
    },
  });
});

export const DeletePermissionDialogComponent = ({
  title,
  handleCancel,
  handleDelete,
  saving,
}: DeletePermissionDialogComponentProps) => {
  const classes = useStyles();
  return (
    <Dialog open={true}>
      <DialogTitle className={classes.tabHeader}>{title}</DialogTitle>
      <DialogContent>
        Are you sure you want to delete this permission set?
        <br />
        This action cannot be undone.
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          className={classes.deleteButton}
          disabled={saving}
        >
          Yes, delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MockHook.withHookHoc(
  DeletePermissionDialogComponent,
  useDeletePermissionDialogLogic
);
